import { InquiriesTableStyle } from "@components/inquiriesTable/inquiriesTableStyle";
import styled from "styled-components";

export const IncidentsTableStyle = styled(InquiriesTableStyle)`

`;
